@if (isCatOver) {
  <mc-notification
    appearance="error"
    heading="Category weightage exceeds 100"
    [body]="'Total category weightage is ' + fmtCat(catTotal) + '. It must equal exactly 100. Please reduce the values.'"></mc-notification>
}
@if (isCatUnder) {
  <mc-notification
    appearance="warning"
    heading="Category weightage below 100"
    [body]="'Total category weightage is ' + fmtCat(catTotal) + '. Remaining: ' + fmtCat(100 - catTotal) + '.'"></mc-notification>
}

<div class="kpi-groups-grid">
  @for (group of kpiGroups; track group.id) {
    <mc-accordion withborder>
      <mc-accordion-item [id]="'kpiw-' + group.id">
        <div slot="heading" class="accordion-heading">
          <span>{{ group.label }}</span>
          <span class="mds-label accordion-heading-sub mds-neutral--strongest__on-background-color">
            Category Weightage: {{ categoryWeights[group.id] || '0' }}
          </span>
        </div>

        <div slot="body" class="accordion-body">
          <!-- Category weightage row -->
          <div class="weight-row weight-row--header">
            <span class="mds-label weight-label weight-label--bold mds-neutral--default__on-background-color"> Category Weightage </span>
            <div [style.width.px]="inputWidth">
              <mc-input
                fit="small"
                type="number"
                hiddenlabel
                [label]="group.label + ' category weightage'"
                placeholder="0"
                [disabled]="readonly"
                [value]="categoryWeights[group.id]"
                (input)="onCatWeightChange(group.id, $event)"></mc-input>
            </div>
          </div>

          <!-- Individual KPI rows -->
          @for (kpi of group.kpis; track kpi.id; let rowIdx = $index) {
            <div class="weight-row" [class.weight-row--odd]="rowIdx % 2 !== 0">
              <span class="mds-body mds-neutral--default__on-background-color">{{ kpi.label }}</span>
              <div [style.width.px]="inputWidth">
                <mc-input
                  fit="small"
                  type="number"
                  hiddenlabel
                  [label]="kpi.label + ' weight'"
                  placeholder="0"
                  [disabled]="readonly"
                  [value]="kpiWeights[kpi.id]"
                  [errormessage]="isGroupOver(group) ? ' ' : ''"
                  (input)="onKpiWeightChange(kpi.id, $event)"></mc-input>
              </div>
            </div>
          }

          <!-- Sum row -->
          <div class="weight-row weight-row--sum">
            <span class="mds-label mds-neutral--default__on-background-color sum-label">Sum</span>
            <span class="mds-label sum-value" [style.width.px]="inputWidth" [style.color]="sumColor(group)">
              {{ fmt(groupSum(group)) }} / {{ categoryWeights[group.id] || '0' }}
            </span>
          </div>

          @if (isGroupOver(group)) {
            <mc-notification
              appearance="error"
              [body]="
                'Sum (' +
                fmt(groupSum(group)) +
                ') exceeds the total of ' +
                (categoryWeights[group.id] || '0') +
                '. Please reduce individual KPI weights.'
              "></mc-notification>
          }
          @if (isGroupUnder(group)) {
            <mc-notification
              appearance="warning"
              [body]="
                'Sum (' +
                fmt(groupSum(group)) +
                ') is less than the total of ' +
                (categoryWeights[group.id] || '0') +
                '. Remaining: ' +
                fmt(groupRemaining(group)) +
                '.'
              "></mc-notification>
          }
        </div>
      </mc-accordion-item>
    </mc-accordion>
  }
</div>
